export const CTransactionReceiverKeyword = {
    SAVING: "saving", 
} as const

export const CTransactionTranslates = {
    SAVING_GOAL_NAME_TRANSACTION: "PARENT_DASHBOARD.TRANSACTION_SAVING_GOAL"
} as const